import { ReactElement } from 'react';

import { DemoNotification } from '@dreryk/demo-variant-frontend';
import { Translate } from '@dreryk/react-common';
import { ActionInput, NotificationSize, NotificationType, StyledFlex, Text } from '@dreryk/react-components';

import { medicineSelectorTranslationKeys } from '../../../../translations';
import { MedicineSelectorFormController } from '../medicineSelector.types';

import {
   StyledMedicineSelectorActionInputCustomContent,
   StyledMedicineSelectorActionInputLabel,
} from './MedicineSelectorActionInput.styled';

type MedicineSelectorActionInputProps = Pick<MedicineSelectorFormController, 'register'> & {
   readonly labelCustomContent: ReactElement;
};

export const MedicineSelectorActionInput = (props: MedicineSelectorActionInputProps): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={'4px'}>
         <StyledFlex alignItems={'flex-start'} gap={'8px'}>
            <StyledMedicineSelectorActionInputLabel>
               <Text testId={'medicineSelectorActionInputLabel'} as={'strong'}>
                  <Translate>{medicineSelectorTranslationKeys.input.label}</Translate>
               </Text>
            </StyledMedicineSelectorActionInputLabel>
            <StyledMedicineSelectorActionInputCustomContent alignItems={'flex-start'} justifyContent={'space-between'}>
               {props.labelCustomContent}
            </StyledMedicineSelectorActionInputCustomContent>
         </StyledFlex>
         <ActionInput
            controller={props.register('medicineSearchText')}
            placeholder={medicineSelectorTranslationKeys.input.placeholder}
            autoFocus
            testId={'medicineSearch'}
         />
         <DemoNotification
            type={NotificationType.INFO}
            label={medicineSelectorTranslationKeys.demoNotification}
            size={NotificationSize.SMALLER}
            testId={'demo'}
         />
      </StyledFlex>
   );
};
